import PaymentMethod from './payment-method';

export default class PaymentMethodDesktop extends PaymentMethod {
}
